// =================================================================================================
// MRTS RUN STATES
// =================================================================================================
export const STATE_INTRODUCTION = 'state_introduction';
export const STATE_INSTRUCTIONS = 'state_instructions';
export const STATE_MAIN_COUNTDOWN = 'state_main_countdown';
export const STATE_MAIN_COUNTDOWN_ENDPAUSE = 'state_main_countdown_endpause';
export const STATE_SCENE = 'state_scene';
export const STATE_SCENE_RESULT = 'state_scene_result';
export const STATE_SCENE_SCOREBOARD = 'state_scene_scoreboard';
export const STATE_END = 'state_end';
export const STATE_GAMEOVER = 'state_gameover'; // The MRTS name for "STATE_END"
export const STATE_WINNER = 'state_winner';
export const STATE_GAME_WINNER = 'state_game_winner'; // The MRTS name for "STATE_WINNER"
export const STATE_MAIN_SCOREBOARD = 'state_main_scoreboard';
export const STATE_INTERMISSION = 'state_intermission';

// =================================================================================================
// WEB POLL STATE CONSTANTS
// =================================================================================================
export const STATE_OPEN = 'state_open';
export const STATE_CLOSED = 'state_closed';
export const STATE_DRAFT = 'state_draft';

// =================================================================================================
// SCENE CONSTANTS
// =================================================================================================
export const SCENE_TYPE_PREDICTION = 'prediction';
export const SCENE_TYPE_QUIZ = 'trivia';
export const SCENE_TYPE_SURVEY = 'survey';

// =================================================================================================
// PRODUCT CONSTANTS
// =================================================================================================
/**
 * Name of the group of those products considered "multichoice products". E.g., Hot or Not. For a
 * list of products in the group, see TITLE_PRODUCTS.
 */
export const MULTICHOICE_PRODUCT = 'multichoice';

/**
 * Name of the group of those products considered "rating products". E.g., Five Stars. For a
 * list of products in the group, see RATING_PRODUCTS.
 */
export const RATING_PRODUCT = 'rating';

/**
 * Name of the group of those products considered "title products". For a list of products in the
 * group, see TITLE_PRODUCTS.
 */
export const TITLE_PRODUCT = 'title';

/**
 * Name of the group of those products considered "social products". Any product that ends in "totv"
 * is considered a "social products". (e.g, tweettotv, facebooktotv, etc).
 */
export const SOCIAL_PRODUCT = 'social';

/**
 * The official list of "multichoice products" (i.e., scenes with multiple choice questions, such as Reader's Choice and Pic Pick).
 */
export const MULTICHOICE_PRODUCTS = ['readerschoice', 'viewerschoice', 'picpick', 'hotornot','faceoff','livereactions','configurablepoll'];

/**
 * The official list of "rating products" (i.e., scenes with an audience average (e.g., Five Stars) or enabling reactions).
 */
export const RATING_PRODUCTS = ['fivestars', 'guessgauge', 'moodmeter'];

/**
 * The official list of "title products" (i.e., scenes that contain title captions, such as Bulletin and Teaser).
 */
export const TITLE_PRODUCTS = ['bulletin', 'teaser', 'poster'];

/**
 * Official names for the available Megaphone TV products.
 */
export const PRODUCTNAME_BLANK = 'blank';
export const PRODUCTNAME_BULLETIN = 'bulletin';
export const PRODUCTNAME_CONFIGURABLEPOLL = 'configurablepoll';
export const PRODUCTNAME_FACEBOOKTOTV = 'facebooktotv';
export const PRODUCTNAME_FACEOFF = 'faceoff';
export const PRODUCTNAME_FIVESTARS = 'fivestars';
export const PRODUCTNAME_GUESSGAUGE = 'guessgauge';
export const PRODUCTNAME_HOTORNOT = 'hotornot';
export const PRODUCTNAME_INSTAGRAMTOTV = 'instagramtotv';
export const PRODUCTNAME_LIVEREACTIONS = 'livereactions';
export const PRODUCTNAME_MOODMETER = 'moodmeter';
export const PRODUCTNAME_PICPICK = 'picpick';
export const PRODUCTNAME_POSTER = 'poster';
export const PRODUCTNAME_READERSCHOICE = 'readerschoice';
export const PRODUCTNAME_SCOREBOARD = 'scoreboard';
export const PRODUCTNAME_TEASER = 'teaser';
export const PRODUCTNAME_TWEETTOTV = 'tweettotv';
export const PRODUCTNAME_UGC = 'ugc';
export const PRODUCTNAME_VIEWERSCHOICE = 'viewerschoice';
export const PRODUCTNAME_WEBPOLL = 'webpoll';
export const PRODUCTNAME_WHATSAPPTOTV = 'whatsapptotv';

// =================================================================================================
// CLIENT CONSTANTS
// =================================================================================================
export const CLIENT_TYPE_SCREEN = 'screen';
export const CLIENT_TYPE_CONTROLLER = 'controller';


